import {getEnv, initializePagewebEnv} from '../common/env/env';
import {ServerEnv} from '../common/env/ServerEnv.enum';
import {requestContext} from '../common/requestContext';
import {IS_CLIENT_SIDE} from '../common/shared/utils/constants';
import {Variables} from './Variables.interface';

/**
 * 인자로 받은 variables 로 초기화합니다.
 * 초기화는 다음 프로세스에서 진행됩니다
 *   - Next.js 서버 번들 파일(_app.tsx 등)
 *   - 클라이언트(CSR) 첫 로드 부분
 */
export function initializeVariables(variables: Variables) {
  requestContext.requestInfo = variables.requestInfo;
  initializePagewebEnv(variables.env);

  // 디버깅을 편하게 하기 위해 개발환경에만 콘솔에서 접근할 수 있도록 합니다
  if (IS_CLIENT_SIDE && getEnv().envName !== ServerEnv.Real) {
    // @ts-ignore
    window['variables'] = variables;
  }
}
